<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="400" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="h6">
					<span class="black--text text-uppercase font-weight-bold">Ubah Password</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-form ref="formChangePassword" role="form" @submit.prevent="save">
						<v-row align="center" justify="center">
							<v-col cols="12">
								<div class="pt-4">
									<div class="text-body-1 font-weight-bold pb-1">Password Lama</div>
									<v-text-field outlined dense v-model="oldpassword" :type="typeInput0" :append-icon="icon0" @click:append="showPassword0" hide-details="auto" @focus="() => responseError.old=''" :error-messages="responseError.old" validate-on-blur :rules="rules.password"></v-text-field>
								</div>
							</v-col>
							<v-col cols="12">
								<div>
									<div class="text-body-1 font-weight-bold pb-1">Password Baru</div>
									<v-text-field outlined dense v-model="password" :type="typeInput" :append-icon="icon" @click:append="showPassword" hide-details="auto" @focus="() => responseError.new=''" :error-messages="responseError.new" validate-on-blur :rules="rules.password"></v-text-field>
								</div>
							</v-col>
							<v-col cols="12">
								<div>
									<div class="text-body-1 font-weight-bold pb-1">Ulangi Password</div>
									<v-text-field outlined dense v-model="repassword" :type="typeInput2" :append-icon="icon2" @click:append="showRepassword" hide-details="auto" @focus="() => alertRepassword=''" :error-messages="alertRepassword" validate-on-blur :rules="rules.password"></v-text-field>
								</div>
							</v-col>
						</v-row>
					</v-form>
					<v-row>
						<v-col cols="12" class="text-center">
							<v-btn depressed color="primary" large class="text-capitalize font-weight-bold text-body-2 rounded-lg" @click="save">Simpan</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			oldpassword: '',
			password: '',
			repassword: '',
			alertRepassword: '',
			typeInput0: 'password',
			icon0: 'mdi-eye',
			typeInput: 'password',
			icon: 'mdi-eye',
			typeInput2: 'password',
			icon2: 'mdi-eye',
			rules: {
				password: [
				v => !!v || 'Tidak boleh kosong',
				],
			},
		}
	},
	props: {
		selectedUser: String,
		filter: Object,
		type: String,
	},
	computed: {
		...mapState('profile', ['responseError']),
	},
	methods: {
		...mapMutations('profile', ['validationError']),

		showPassword0() {
			this.typeInput0 = this.typeInput0 == 'text' ? 'password' : 'text'
			this.icon0 = this.icon0 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		showRepassword() {
			this.typeInput2 = this.typeInput2 == 'text' ? 'password' : 'text'
			this.icon2 = this.icon2 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		modalShow() {
			this.dialog = true
			this.validationError({})
			this.oldpassword = ''
			this.password = ''
			this.repassword = ''
		},
		modalHide() {
			this.dialog = false
		},
		save() {
			if (this.password !== this.repassword) {
				this.alertRepassword = "Password tidak sama"
			} else {
				this.alertRepassword = ''
				if (this.$refs.formChangePassword.validate()) {
					let params = {
						old: this.oldpassword,
						new: this.password
					}
					this.$emit('action', params)
				}
			}
		},
	},
};
</script>